import MyIcon from "@/components/MyIcon";
import { GetDataList as getDepartmentList } from "@/services/system/departmentService";
import { GetDataList } from "@/services/system/sysCodeService";
import { GetDataList as getUserList } from "@/services/system/userService";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { SettingDrawer } from "@ant-design/pro-components";
import "@ant-design/v5-patch-for-react-19";
import type { RequestConfig, RunTimeLayoutConfig } from "@umijs/max";
import { history, Link } from "@umijs/max";
import { message, notification } from "antd";
import { stringify } from "qs";
import { useState } from "react";
import defaultSettings from "../config/defaultSettings";
import RightContent from "./components/RightContent";
import { APPConfig } from "./config/common";
import { getCurrentUser, getUserMenu } from "./services/system/userService";
import { getSysConfig } from "./utils/SysConfigUtils";
import {
  getLocalStorageByExpire,
  getPageQuery,
  TreeHelper,
} from "./utils/utils";
const isDev = process.env.NODE_ENV === "development";

/**
 * @see https://umijs.org/docs/api/runtime-config#getinitialstate
 * */
export async function getInitialState(): Promise<any> {
  let currentPath = history.location.pathname;

  if (currentPath !== "/" && currentPath.endsWith("/")) {
    currentPath = currentPath.slice(0, -1);
  }
  // 如果是登录页面，不执行
  if (APPConfig.noNeedLogin.every((item) => currentPath != item)) {
    return {
      currentUser:
        getLocalStorageByExpire("sessionid") && (await getCurrentUser({})),
      sessionid: getLocalStorageByExpire("sessionid"),
      settings: localStorage.getItem("themeSettings")
        ? {
            ...defaultSettings,
            ...JSON.parse(localStorage.getItem("themeSettings") || "{}"),
          }
        : defaultSettings,
      menuList: getLocalStorageByExpire("sessionid") && (await getUserMenu({})),
      codelist: getLocalStorageByExpire("sessionid") && (await GetDataList()),
      userList:
        getLocalStorageByExpire("sessionid") &&
        (await getUserList({ noLimit: true })),
      departmentList:
        getLocalStorageByExpire("sessionid") &&
        (await getDepartmentList({ isAll: true })),
      // menuType: localStorage.getItem("menuType"),
      menuType: "xtgl",
    };
  } else {
    return {
      settings: localStorage.getItem("themeSettings")
        ? {
            ...defaultSettings,
            ...JSON.parse(localStorage.getItem("themeSettings") || "{}"),
          }
        : defaultSettings,
      // menuType: localStorage.getItem("menuType"),
      menuType: "xtgl",
    };
  }
  return {
    settings: defaultSettings,
  };
}

// ProLayout 支持的api https://procomponents.ant.design/components/layout
export const layout: RunTimeLayoutConfig = ({
  initialState,
  setInitialState,
  refresh,
}) => {
  const [settingDrawerCollapsed, setSettingDrawerCollapsed] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  let currentPath = history.location.pathname;
  if (currentPath !== "/" && currentPath.endsWith("/")) {
    currentPath = currentPath.slice(0, -1);
  }
  return {
    // headerTitleRender: () => (
    //   <a title="首页" href="/">
    //     <h1 style={{ color: "white" }}>
    //       {getSysConfig(initialState, window.location.host).title}
    //     </h1>
    //   </a>
    // ),

    title:
      // <span
      //   style={{
      //     color:
      //       initialState.settings.layout == "mix" ||
      //       initialState.settings.layout == "side"
      //         ? "white"
      //         : "black",
      //   }}
      // >
      getSysConfig(initialState, window.location.host).title,
    // </span>

    onMenuHeaderClick: () => {
      // 判断是否有home的权限，如果没有的话跳转到个人中心
      if (initialState?.menuList?.data) {
        let allMenu = TreeHelper.GetAllByTree(initialState?.menuList?.data, []);
        allMenu = allMenu.concat(
          APPConfig.whiteList.map((item) => ({ path: item }))
        );
        let hasPermission = allMenu.some((item) => "/home" == item.path);
        if (!hasPermission) {
          // window.location.href = "/backhome";
          return;
        }
      }
      window.location.href = "/";
    },
    menuDataRender: () => {
      const newMenuData = initialState?.menuList?.data;
      return JSON.parse(JSON.stringify(newMenuData || []));
    },
    subMenuItemRender: (HeaderViewProps) => {
      return (
        <p
          style={{
            marginTop:
              collapsed && initialState?.settings.layout != "top"
                ? "0"
                : "10px",
            textAlign:
              collapsed && initialState?.settings.layout != "top"
                ? "center"
                : "left",
          }}
        >
          <MyIcon
            type={`icon-${HeaderViewProps.icon}`}
            style={{ fontSize: "20px" }}
          />
          {collapsed && initialState?.settings.layout != "top" ? (
            ""
          ) : (
            <span style={{ paddingLeft: "2px" }}>{HeaderViewProps.name}</span>
          )}
        </p>
      );
    },
    menuItemRender: (menuItemProps: {
      icon: string;
      name: string;
      path: any;
    }) => {
      let currentPath = menuItemProps.path;
      if (currentPath !== "/" && currentPath.endsWith("/")) {
        currentPath = currentPath.slice(0, -1);
      }
      return (
        <Link to={currentPath}>
          {menuItemProps.icon ? (
            <MyIcon
              type={`icon-${menuItemProps.icon}`}
              style={{ fontSize: "20px" }}
            />
          ) : (
            <>
              <span
                style={{
                  // marginLeft: "15px",
                  fontSize: "18px",
                  fontWeight: "bold",
                }}
              >
                -
              </span>
            </>
          )}

          <span style={{ paddingLeft: "2px" }}>{menuItemProps.name}</span>
        </Link>
      );
    },
    rightContentRender: () => <RightContent />,
    footerRender: () => <></>,
    onPageChange: () => {
      // setFavicon(getSysConfig(initialState, window.location.host).logoImageUrl);
      // 如果没有登录，重定向到 login
      if (
        !initialState?.sessionid &&
        APPConfig.noNeedLogin.every((item) => currentPath != item)
      ) {
        // console.log(
        //   currentPath,
        //   APPConfig.noNeedLogin,
        //   APPConfig.noNeedLogin.every((item) => currentPath != item)
        // );

        localStorage.removeItem("menuType");
        localStorage.removeItem("sessionid");
        const { redirect } = getPageQuery();
        if (currentPath !== "/user/login" && !redirect) {
          history.replace({
            pathname: "/user/login",
            search: stringify({
              redirect: window.location.href,
            }),
          });
        } else {
          history.push("/user/login");
        }
        return;
      }
      // 权限判断
      if (currentPath) {
        let allMenu = TreeHelper.GetAllByTree(initialState?.menuList?.data, []);
        allMenu = allMenu.concat(
          APPConfig.whiteList.map((item) => ({ path: item }))
        );
        let hasPermission = allMenu.some((item) => currentPath == item.path);
        if (currentPath.indexOf("/h5") >= 0) {
          hasPermission = true;
        }

        if (!hasPermission) {
          history.push("/403");
        }
      }
    },

    menuHeaderRender: undefined,
    // 自定义 403 页面
    // unAccessible: <div>unAccessible</div>,
    // 增加一个 loading 的状态
    childrenRender: (children) => {
      // if (initialState?.loading) return <PageLoading />;
      return (
        <>
          {children}

          <SettingDrawer
            disableUrlParams
            hideCopyButton
            enableDarkTheme={false}
            onCollapseChange={(e) => {
              setSettingDrawerCollapsed(e);
            }}
            settings={initialState?.settings}
            onSettingChange={(settings) => {
              localStorage.setItem("themeSettings", JSON.stringify(settings));
              if (settings.layout == "top") {
                message.info(
                  "导航模式为顶部菜单时，内容区域宽度建议设置为流式"
                );
              }
              settingDrawerCollapsed && message.success("保存设置成功");
              setInitialState((preInitialState: any) => ({
                ...preInitialState,
                settings: {
                  ...settings,
                  logo: getSysConfig(initialState, window.location.host)?.logoImageUrl2,
                  title: getSysConfig(initialState, window.location.host).title,
                },
              }));
              // refresh();
            }}
          />
        </>
      );
    },
    collapsed: collapsed,
    collapsedButtonRender: (isCollapsed) => {
      return (
        <div
          style={{ display: "flex", alignItems: "center", alignContent: "end" }}
          onClick={() => {
            setCollapsed(!isCollapsed);
          }}
        >
          {collapsed ? (
            <MenuUnfoldOutlined
              style={{
                fontSize: "28px",
                color: initialState.settings.colorPrimary,
              }}
            />
          ) : (
            <MenuFoldOutlined
              style={{
                fontSize: "28px",
                color: initialState.settings.colorPrimary,
              }}
            />
          )}
        </div>
      );
    },
    ...initialState?.settings,
  };
};

const codeMessage = {
  200: "服务器成功返回请求的数据。",
  201: "新建或修改数据成功。",
  202: "一个请求已经进入后台排队（异步任务）。",
  204: "删除数据成功。",
  400: "发出的请求有错误，服务器没有进行新建或修改数据的操作。",
  401: "用户没有权限（令牌、用户名、密码错误）。",
  403: "用户得到授权，但是访问是被禁止的。",
  404: "发出的请求针对的是不存在的记录，服务器没有进行操作。",
  405: "请求方法不被允许。",
  406: "请求的格式不可得。",
  410: "请求的资源被永久删除，且不会再得到的。",
  422: "当创建一个对象时，发生一个验证错误。",
  500: "服务器发生错误，请检查服务器。",
  502: "网关错误。",
  503: "服务不可用，服务器暂时过载或维护。",
  504: "网关超时。",
};

/**
 * 异常处理程序
 */
const errorHandler = (error: ResponseError) => {
  const { name } = error;
  console.log("error", error);

  if (name === "ResponseError") {
    const { response } = error;
    const errorText = codeMessage[response.status] || response.statusText;
    const { status } = response;

    notification.error({
      message: `请求错误 ${status}`,
      description: errorText,
    });
    return {
      data: null,
      statecode: status,
      success: false,
      msg: `请求错误 ${status}`,
    };
  }
  if (name === "BizError") {
    // const { data } = error;
    // const { statecode, msg } = data;
    // const errorText = codeMessage[statecode] || msg;
    // notification.error({
    //   message: `请求错误 ${statecode}`,
    //   description: errorText,
    // });
    // if (statecode == 1001 || statecode == 401) {
    //   localStorage.removeItem("sessionid");
    //   history.push({
    //     pathname: "/user/login",
    //   });
    // }
    // return data;
  }
  if (name === "TypeError") {
    notification.error({
      description: "请求的资源不存在",
      message: "请求错误",
    });
    return {
      data: null,
      statecode: 404,
      success: false,
      msg: "请求的资源不存在",
    };
  }

  notification.error({
    description: "您的网络发生异常，无法连接服务器",
    message: "网络异常",
  });
  return {
    data: null,
    statecode: -1000,
    success: false,
    msg: "您的网络发生异常，无法连接服务器",
  };
};
const requestInterceptor = async (url: any, options: any) => {
  if (getLocalStorageByExpire("sessionid")) {
    let headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      sessionid: getLocalStorageByExpire("sessionid"),
    };
    if (options.headers) {
      headers = { ...headers, ...options.headers };
    }

    return {
      url,
      options: { ...options, headers },
    };
  }

  return {
    url,
    options: { ...options },
  };
};
// 响应拦截
const responseInterceptors = async (response: any) => {
  const res = response; // Umi 已经自动解析了 JSON，直接使用即可
  const result: any = {};
  const { statecode, data, message } = res?.data;
  // 如果是分页的 字段调整为datalist
  if (
    statecode === 0 &&
    Object.prototype.toString.call(data) === "[object Object]" &&
    data.datalist
  ) {
    result.data = data.datalist;
    result.pagination = data.pagination;
  } else {
    result.data = data;
  }
  if (statecode != 0) {
    if (statecode == 1001 || statecode == 401) {
      localStorage.removeItem("sessionid");
      history.push({
        pathname: "/user/login",
      });
    } else {
      notification.error({
        message: `请求错误 ${statecode}`,
        description: message,
      });
    }
  }
  return {
    data: {
      ...result,
      statecode,
      success: statecode == 0,
      msg: message,
      total: result?.pagination?.total,
    },
  };
};
export const request: RequestConfig = {
  // 错误处理： umi@3 的错误处理方案。
  errorConfig: {
    // 错误抛出
    errorThrower: (res) => {
      // const { success, data, errorCode, errorMessage, showType } =
      //   res as unknown as ResponseStructure;
    },
    // 错误接收及处理
    errorHandler: (error: any, opts: any) => {
      errorHandler(error);
    },
  },
  //@ts-ignore
  requestInterceptors: [requestInterceptor],
  responseInterceptors: [responseInterceptors],
};
